import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';

import { UppyTusWrapper } from '@components/common/uppy/uppy_ucs/UppyTusWrapper';
import { UppyFeatureFlagWrapper } from '@components/common/uppy/UppyFeatureFlagWrapper';
import { formattedUppyAttachment, isUppyWithCompanionEnabled } from '@helpers/uppy';

class VideoWatermarkUppy extends React.Component {
  triggerClickHandlerRef = React.createRef();

  handleUpload = (files) => {
    if (!files.length) { return; }
    const file = formattedUppyAttachment(files[0]);
    this.props.onUpload(file)
  }

  uploadType = () => this.props.uploadType.toLowerCase();

  trigger = () => `uppy-trigger-${this.uploadType()}`;

  handleTriggerClick = (event) => {
    if (this.triggerClickHandlerRef.current) {
      this.triggerClickHandlerRef.current(event);
    }
  }

  renderArea = () => (
    <div className="uppy-video-watermark" id={this.trigger()} onClick={this.handleTriggerClick}>
      <p><Trans>Click to upload watermark</Trans></p>
    </div>
  );

  render() {
    const UploaderComponent = isUppyWithCompanionEnabled()
      ? UppyTusWrapper
      : UppyFeatureFlagWrapper;

    return (
      <React.Fragment>
        {this.renderArea()}
        <UploaderComponent
          {...this.props}
          button
          handleUpload={this.handleUpload}
          locale={{ strings: { dropPaste: "Drag a file here or %{browse}", browse: "click to browse"} }}
          onTriggerClickHandler={this.triggerClickHandlerRef}
          restrictions={{ maxNumberOfFiles: 1, allowedFileTypes: ['.jpg', '.jpeg', '.png', '.bmp', '.gif'] }}
          template={this.uploadType()}
          trigger={`#${this.trigger()}`}
          uniqIdentifier={`uppy-${this.uploadType()}`}
        />
      </React.Fragment>
    );
  }
}

VideoWatermarkUppy.propTypes = {
  uploadType: PropTypes.string.isRequired
};

export default VideoWatermarkUppy;
